export enum EAuthUrls {
  AUTH = 'auth',
  IS_ADMIN = 'is-admin',
  AUTHENTICATION_FLOWS = 'authentication-flows',
  FORGOT_PASSWORD = 'forgot-password',
  TEMPORARY_PASSWORD = 'temporary-password',
}
